import React from 'react';

const ELogbook = React.lazy(() => import('./ELogbook'))
const PersetujuanKegiatan = React.lazy(() => import('./PersetujuanKegiatan'))
const DaftarKegiatan = React.lazy(() => import('./ELogbook/DaftarKegiatan'))
const PermintaanVerifikasi = React.lazy(() => import('./PersetujuanKegiatan/PermintaanVerifikasi'))
const LogActivity = React.lazy(() => import('./LogActivity'))

export const logbookConfigs = [
    {
        path: '/logbook/e-logbook',
        element: <ELogbook />,
    },
    {
        path: '/logbook/persetujuan-kegiatan',
        element: <PersetujuanKegiatan />,
    },
    {
        path: '/logbook/persetujuan-kegiatan/permintaan-verifikasi/:id',
        element: <PermintaanVerifikasi />,
    },
    {
        path: '/logbook/e-logbook/daftar-kegiatan/:id',
        element: <DaftarKegiatan />,
    },
    {
        path: '/logbook/aktivitas',
        element: <LogActivity />,
    },
];
